export type LabelType = 'ORDER' | 'DOCTOR';

type Placeholder = { key: string; description: string };

const PATIENT_AND_DOCTOR: Placeholder[] = [
  { key: 'PATIENT', description: 'Patient Name' },
  { key: 'PATIENTDOB', description: 'Patient Geburtstag' },
  { key: 'PATIENTAISID', description: 'Patient externe AIS-ID' },
  { key: 'SVNR', description: 'Versicherungsnummer' },
  { key: 'DOCTOR', description: 'Zuweiser Name' },
  { key: 'DOCTORID', description: 'Zuweiser Kundennummer' },
];

/** Mirrors LabelType in labrador-api; a placeholder missing here is marked invalid in the editor. */
export const LABEL_PLACEHOLDERS: Record<LabelType, Placeholder[]> = {
  ORDER: [
    ...PATIENT_AND_DOCTOR,
    { key: 'TEXT', description: 'Etikettentext Probenbehälter' },
    { key: 'TEXT2', description: 'Etikettentext Probenbehälter 2' },
    { key: 'LOCATION', description: 'Lokalisation' },
    { key: 'BARCODE', description: 'Etikettennummer unformatiert' },
    { key: 'ID', description: 'UUID des Etiketts' },
    { key: 'RUNID', description: 'Laufende Nummer des Etiketts im Auftrag' },
    { key: 'PRETTYCODE', description: 'Etikettennummer formatiert' },
    { key: 'LAB', description: 'Labor Kurzbezeichnung' },
    { key: 'FEATURES', description: 'Materialeigenschaften' },
    { key: 'STATIONS', description: 'Analysestationen' },
    { key: 'INSURANCE', description: 'Kasse Kurzname bzw. privat' },
    { key: 'ACUTE', description: 'Wenn mind. ein Akutparameter, dann AKUT' },
  ],
  DOCTOR: [
    ...PATIENT_AND_DOCTOR,
    { key: 'BARCODE', description: 'Auftragsnummer unformatiert' },
    { key: 'ID', description: 'UUID des Auftrags' },
    { key: 'LAB', description: 'Labor Kurzbezeichnung' },
    { key: 'INSURANCE', description: 'Kasse Kurzname bzw. privat' },
    { key: 'ACUTE', description: 'Wenn mind. ein Akutparameter, dann AKUT' },
  ],
};

export const placeholderPattern = (labelType: LabelType, flags?: string) =>
  new RegExp(`%(${LABEL_PLACEHOLDERS[labelType].map(p => p.key).join('|')})%`, flags);

/** The placeholders a template uses, in order of first appearance. */
export const placeholdersInTemplate = (zpl: string, labelType: LabelType): Placeholder[] => {
  const known = new Map(LABEL_PLACEHOLDERS[labelType].map(p => [p.key, p]));
  const keys = [...zpl.matchAll(placeholderPattern(labelType, 'g'))].map(match => match[1]);
  return [...new Set(keys)].flatMap(key => known.get(key) ?? []);
};
